//Utilities
import AppDispatcher from '../core/AppDispatcher.jsx';
import { EventEmitter } from 'events';
import _ from 'lodash';
import ApplicationConstants from '../constants/ApplicationConstants.js';
import IDVerificationConstants from '../constants/IDVerificationConstants.js';
import YourDetailsConstants from '../constants/YourDetailsConstants';
import DownloadConstants from '../constants/DownloadConstants';
import Mapper from '../utils/Mapper.js';
import AccountTypes from '../utils/AccountTypes.js';
import Formatter from '../utils/Formatter.js';
import DownloadFormsHelper from '../utils/DownloadFormsHelper.js';
import IdVerificationHelper from '../utils/IdVerificationHelper.js';
import WorkItemHelper from '../utils/WorkItemHelper.js';
//local variables
const CHANGE_EVENT = 'change';
const ApplicationActionTypes = ApplicationConstants.ActionTypes;
const ActionTypes = IDVerificationConstants.ActionTypes;

let _formModel = {},
    _consolidatedFormModel = {},
    _product = {},
    _showMoreMenu = false,
    _electronicSubmissionData = {
        applicantName: '',
        mobileNumber: ''
    },
    _isJoint = false,
    _titleList = [],
    _mobileNumbers = [],
    _applicationId = '',
    _accountNumber = '',
    _hasSubmitFailed,
    _accountType='',
    _showDownloadMenu = false,
    _formsToDownload = [],
    _downloadInProgress = false, 
    _selectedForms = [],
    _readyForDownload = false,
    _downloadedForms = '',
    _formDownloaded = true,
    _downloadFormsFailed = false;
    

function setReviewData(formModel, consolidatedFormModel, product) {
    _formModel = _.cloneDeep(formModel);
    _consolidatedFormModel = _.cloneDeep(consolidatedFormModel);
    _product = _.cloneDeep(product);
    _isJoint = AccountTypes.checkIfJointAccount(_formModel.form.accountType);
    _accountType = _.cloneDeep(formModel.form.accountType);
}

function setIdentificationMode(data) {
    _formModel = IdVerificationHelper.getUpdateFormModelWithKycTypeToUpdate(_formModel, data.kycTypeToUpdate);
}

function setCommSeeBackFile(data) {
    const commSeeBackFile = WorkItemHelper.getCommSeeBackFile(data, _formModel);
    _formModel.form.workItem = WorkItemHelper.getUpdatedFormModel(_formModel, { idVerificationBackFile: commSeeBackFile });
}

function setElectronicSubmission() {
    const data = _formModel.form.yourDetails;
    _mobileNumbers = [];
    if (_isJoint) {
        let applicantNames = '';
        let andString = '';
        let mobileNumbers = '';
        for (let i = 0; i < data.investorList.length; i++) {
            _mobileNumbers.push(data.investorList[i].contactDetails.mobile);
            const title = Mapper.getGenderTitle(data.investorList[i].gender, data.investorList[i].title, _titleList, YourDetailsConstants.Values.GENDER_MALE, YourDetailsConstants.Values.GENDER_FEMALE);
            andString = i > 0 ? ' and ' : '';
            let name = Formatter.formatFullname(title, data.investorList[i].givenName, data.investorList[i].lastName);
            applicantNames = applicantNames + andString + name;
            mobileNumbers = mobileNumbers + andString + Formatter.maskMobileNumber(data.investorList[i].contactDetails.mobile) + ' (' +name + ')'
        }
        _electronicSubmissionData.applicantName = applicantNames;
        _electronicSubmissionData.mobileNumber = mobileNumbers;
    } else {
        _mobileNumbers.push(data.contactDetails.mobile);
        const title = Mapper.getGenderTitle(data.gender, data.title, _titleList, YourDetailsConstants.Values.GENDER_MALE, YourDetailsConstants.Values.GENDER_FEMALE);
        _electronicSubmissionData.applicantName = Formatter.formatFullname(title, data.givenName, data.lastName);
        _electronicSubmissionData.mobileNumber = Formatter.maskMobileNumber(data.contactDetails.mobile);
    }
}

function setApplicationId(id, wipId) {
    _applicationId = id;
    _formModel.id = id;
    _consolidatedFormModel.id = id;
    if (wipId) {
        _formModel.wipId = wipId;    
        _consolidatedFormModel.wipId = wipId;
    }
}

function setAccountNumber(accountNumber){
    _hasSubmitFailed = false;
    _accountNumber = accountNumber;
}

function updateFormModelIdVerification(idVerificationModel) {
    _formModel.form.idVerification = _.cloneDeep(idVerificationModel);
}

function updateYourDetailsForSave() {
    if (_formModel.form) {
        _formModel.form.yourDetails = 
            IdVerificationHelper.formatVerificationDocuments(_formModel.productId, _formModel.form.accountType, _formModel.form.yourDetails, _formModel.form.idVerification);
    }
}

function agreeIdVerificationForm() {
    _formModel.form.yourDetails = 
        IdVerificationHelper.formatVerificationDocuments(_formModel.productId, _formModel.form.accountType, _formModel.form.yourDetails, _formModel.form.idVerification, true);
}

function updateFormModelWorkItem(workItem) {
    _formModel.form.workItem = WorkItemHelper.getUpdatedFormModel(_formModel, workItem);
}
//TODO:: REFACTOR THIS INTO A DOWNLOAD MENU STORE
function toggleDownloadMenu(showDownloadMenu) {
    _showDownloadMenu = showDownloadMenu;
    if (showDownloadMenu && _product && _product.value) {
        _formsToDownload = DownloadFormsHelper.getFormsList(_product.value, _accountType);
    } else {
        _formsToDownload = [];
    }
    _selectedForms = [];
    _downloadInProgress = false;
    _downloadFormsFailed = false;
}

function updateFormsToDownload(index, checked) {
    if (_formsToDownload[index]) {
        _formsToDownload[index].checked = checked;
    }
}

function getSelectedForms() {
    if (_formsToDownload && _formsToDownload.length > 0) {
        _selectedForms = DownloadFormsHelper.getSelectedForms(_formsToDownload);
        _downloadInProgress = true;
    }
}

function receiveDownloadedApplicationForm(data) {
    if (data.attachments && data.attachments.length > 0) {
        let url = DownloadConstants.Base64String;
        _downloadedForms = url.replace('{contentType}', data.attachments[0].contentType).replace('{base64}', data.attachments[0].body);
    }
    _downloadFormsFailed = false;
    _formDownloaded = false;
    _downloadInProgress = false;
    _showDownloadMenu = false;
    _formsToDownload = [];
    _selectedForms = [];
}
//TODO:: REFACTOR THIS INTO A DOWNLOAD MENU STORE
class ElectronicSubmissionStoreClass extends EventEmitter {
    constructor() {
        super();
    }
    addChangeListener(cb) {
        this.on(CHANGE_EVENT, cb);
    }

    removeChangeListener(cb) {
        this.removeListener(CHANGE_EVENT, cb);
    }

    emitChange() {
        return this.emit(CHANGE_EVENT);
    }

    getFormModel() {
        return _formModel;
    }

    getConsolidatedFormModel() {
        return _consolidatedFormModel;
    }

    getProduct() {
        return _product;
    }

    getShowHideMore() {
        return _showMoreMenu;
    }

    getElectronicSubmissionData() {
        return _electronicSubmissionData;
    }

    getIsJoint() {
        return _isJoint;
    }

    getMobileNumbers() {
        return _mobileNumbers;
    }

    getApplicationId() {
        return _applicationId;
    }

    getAccountNumber(){
        return _accountNumber;
    }
    
    getHasSubmitFailed(){
        return _hasSubmitFailed
    }

    getAccountType() {
        return _accountType;
    }

    getShowDownloadMenu() {
        return _showDownloadMenu;
    }
    getFormsToDownload() {
        return _formsToDownload;
    }
    getEnableDownloadButton() {
        let checked = _.where(_formsToDownload, {'checked':true});
        return checked && checked.length > 0;
    }
    getDownloadInProgress() {
        return _downloadInProgress;
    }
    getSelectedForms() {
        return _selectedForms;
    }
    getReadyForDownload() {
        return _readyForDownload === true && _downloadInProgress === true;
    }
    getDownloadedForms() {
        return _downloadedForms;
    }
    getIsFormsDownloaded() {
        return _formDownloaded;
    }
    getDownloadFormsFailed() {
        if (_downloadInProgress) {
            return false;
        }
        return _downloadFormsFailed;
    }
}

// Initialize the singleton to register with the
// dispatcher and export for React components
const ElectronicSubmissionStore = new ElectronicSubmissionStoreClass();

// Register each of the actions with the dispatcher
// by changing the store's data and emitting a change
ElectronicSubmissionStore.dispatchToken = AppDispatcher.register((action) => {

    switch (action.actionType) {
        case ApplicationActionTypes.APPLICATION_SAVE_REQUEST:
        case ApplicationActionTypes.APPLICATION_SAVE_STARTING:
            updateYourDetailsForSave();
            break;
        case ApplicationActionTypes.CLIENT_IDENTIFICATION_MODE_LOADED:
            setIdentificationMode(action.data);
            break;
        case ApplicationActionTypes.SET_COMMSEE_BACKFILE:
            setCommSeeBackFile(action.data);
            break;
        case ApplicationActionTypes.AGREE_IDVERIFICATION_FORM:
            agreeIdVerificationForm();
            break;
        case ApplicationActionTypes.REVIEW_APPLICATION:
            setReviewData(action.formModel, action.consolidatedFormModel, action.product);
            break;
        case ApplicationActionTypes.UPDATE_WORKITEM:
            updateFormModelWorkItem(action.workItem);
            break;
        case ApplicationActionTypes.UPDATE_VERIFICATOIN_DOCUMENT:
            updateFormModelIdVerification(action.data);
            break;
        case ApplicationActionTypes.SHOW_MORE_MENU:
            _showMoreMenu = action.showMoreMenu;
            break;
        case ActionTypes.GO_TO_ELECTRONIC_SUBMISSION_PAGE:
            setElectronicSubmission();
            break;
        case ApplicationActionTypes.LOAD_TITLE_LIST:
            _titleList = action.titles;
            break;
        case ApplicationActionTypes.APPLICATION_SAVE_SUCCESS:
            setApplicationId(action.applicationId, action.wipId);
            break;
        case ApplicationActionTypes.APPLICATION_SUBMIT_SUCCESS:
            setAccountNumber(action.data.accountNumber);
            break;
        case ApplicationActionTypes.APPLICATION_SUBMIT_FAILED:
            _hasSubmitFailed = true;
            _formModel.submitDate = '';
            break;
        case ApplicationActionTypes.SHOW_DOWNLOAD_MENU:
            toggleDownloadMenu(action.showDownloadMenu);
            break;
        case ApplicationActionTypes.UPDATE_FORMS_TO_DOWNLOAD:
            updateFormsToDownload(action.index, action.checked);
            break;
        case ApplicationActionTypes.PREPARE_FORMS_TO_DOWNLOAD:
            getSelectedForms();
            break;
        case ApplicationActionTypes.APPLICATION_DOWNLOAD_REQUEST:
            _readyForDownload = true;
            break;
        case ApplicationActionTypes.START_DOWNLOADING_FORMS:
            _readyForDownload = false;
            break;
        case ApplicationActionTypes.DOWNLOAD_FORMS_SUCCESS:
            receiveDownloadedApplicationForm(action.data);
            break;
        case ApplicationActionTypes.CLEAR_DOWNLOADED_FORMS:
            _downloadedForms = undefined;
            _formDownloaded = true;
            _selectedForms = [];
            break;
        case ApplicationActionTypes.DOWNLOAD_FORMS_FAILED:
            _downloadInProgress = false;
            _formDownloaded = true;
            _downloadFormsFailed = true;
            break;
        default:
            return true;
    }

    ElectronicSubmissionStore.emitChange();
    return true;
});

export default ElectronicSubmissionStore;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./stores/ElectronicSubmissionStore.js